import { DataTable } from "@/components/molecules/tables/data-table";
import { useTranslation } from "@/features/utils/i18n";
import { PageLayout } from "../layout";
import { useExternalAccountsBulkActions } from "./components/bulk-actions";
import { useExternalAccountsColumns } from "./components/columns";
import { ConnectAccountDialog } from "./components/connect-dialog";
import { GlobalSyncSettings } from "./components/global-sync-settings";
import { SyncSummaryCard } from "./components/sync-summary-card";
import { useExternalAccountsPage } from "./use-external-accounts-page";

export const AccountsListPage = () => {
  const { t } = useTranslation("externalAccounts");
  const { accounts, isLoading } = useExternalAccountsPage();
  const bulkActions = useExternalAccountsBulkActions();
  const columns = useExternalAccountsColumns();

  return (
    <PageLayout
      width="medium"
      title={t("externalAccounts.title")}
      description={t("externalAccounts.description")}
      actions={
        <div className="flex items-center space-x-2">
          <GlobalSyncSettings />
          <ConnectAccountDialog />
        </div>
      }
    >
      <div className="space-y-6">
        <SyncSummaryCard />
        <DataTable
          hideSearch
          columns={columns}
          data={accounts || []}
          isLoading={isLoading}
          bulkActions={bulkActions}
        />
      </div>
    </PageLayout>
  );
};
